export function getImagePath(coin) {
    try {
        return require('@/assets/images/coin_logos/' + coin.toLowerCase() + '.svg');
    } catch {
        return require('@/assets/images/coin_logos/default.svg');
    }
}